import Swal from '../utils/swal'
import EmailValidation from "./validation/email-validation";

require('./../scss/customer-register.scss');

const CustomerAddress = require('./includes/customer-address');

let customerRegister = new function () {

};

customerRegister.init = function () {
    this._bindEvents();
};

customerRegister._bindEvents = function () {
    CustomerAddress.init();

    $('.invoice-address-container input, .invoice-address-container select').on('change', function(e){
        const field = $(this).data('invoice-input');
        const value = (field !== 'country')? e.currentTarget.value : e.currentTarget[e.currentTarget.selectedIndex].innerText;
        $('.invoice-address-' + field).text(value);
    });

    if ($('#invoice_address_edit').length === 1) {
        $('#invoice_address_edit').on('click', function (e) {
            e.preventDefault();

            $('.invoice-address-container').toggle();
        });
    }

    if ($('#content-account-company-register[data-auto-submit]').length === 1) {
        $('form[name=company]').submit();
    }
};

customerRegister.init();
